import React, { Component } from 'react';
import './TextFieild.scss';
import TextField from '@material-ui/core/TextField';
import { domainName, domainMap } from '../../config';

type initialProps = {
    value: any;
    onChange?: any;
    label?: string;
    placeholder?: string;
    error?: boolean;
    disabled?: boolean;
    helperText?: string;
    type?: string;
    maxlength?: number;
    minLength?: number;
    onBlur?: any;
    className?: string;
    multiline?: boolean;
    rows?: number;
    rowsMax?: number;
    endAdornment?: any;
    readOnly?: boolean;
    autoFocus?: boolean;
    name?: string;
    id?: any;
};

type initialState = {};
export default class TextFieldComponent extends Component<initialProps, initialState> {
    render() {
        return (
            <TextField
                onBlur={this.props.onBlur}
                className={
                    domainName === domainMap.T2
                        ? `TextFieldEarthlink ${this.props.className ? this.props.className : ''}`
                        : `TextField ${this.props.className ? this.props.className : ''}`
                }
                label={this.props.label}
                type={this.props.type}
                placeholder={this.props.placeholder}
                {...(this.props.id && { id: this.props.id })}
                onChange={this.props.onChange}
                variant="filled"
                value={this.props.value}
                error={this.props.error}
                helperText={this.props.helperText}
                disabled={this.props.disabled}
                inputProps={{
                    autoComplete: 'new-password',
                    form: {
                        autoComplete: 'off',
                    },
                    maxLength: this.props.maxlength,
                    minLength: this.props.minLength,
                    readOnly: this.props.readOnly,
                }}
                InputProps={{ endAdornment: this.props.endAdornment }}
                multiline={this.props.multiline}
                rows={this.props.rows}
                rowsMax={this.props.rowsMax}
                name={this.props.name}
            />
        );
    }
}
